import { fromPairs, times } from 'lodash';
import { BooleanParam, DelimitedArrayParam, StringParam } from 'use-query-params';

import { MAX_VIEWERS } from 'components/Procedure/SlidesViewer/constants';
import { resultReviewIntentParam } from 'components/Procedure/resultReviewIntent';
import { ANALYSIS_AREAS_EXPLORE_PARAM } from 'components/StudyDashboard/Workflow/analysisAreasExplore';
import { annotationAssignmentIdViewerQuerySchema } from 'services/annotations/useAnnotationQueryParams';
import { CompressedJsonParam } from 'utils/customQueryParamsConfigs';
import { markerChannelHistogramsQueryParam } from '../../SlideControls/Multiplex/channelHistogramParams';

export const additionalNavigationParamsSchema = {
  slideQualityActionsDrawerOpen: BooleanParam,
  showAllJobsInCasePage: BooleanParam,
  slideIdForReviewing: StringParam,
  slidesThumbnailsDrawerOpen: BooleanParam,
  slideTagsDrawerOpen: BooleanParam,
  useOSDViewer: BooleanParam,
  fullscreenViewer: BooleanParam,
  reviewTab: StringParam,
  [ANALYSIS_AREAS_EXPLORE_PARAM]: BooleanParam,
  fromStudyFilter: StringParam,
  annotationsListVisibility: StringParam,
  stainToBaseSlideSettings: CompressedJsonParam,
  componentStainTypeIdToDeconvolutionComponentsVisual: CompressedJsonParam,
  layerSettingsPerStainAndDisplayName: CompressedJsonParam,
  markerChannelColorSettings: CompressedJsonParam,
  markerChannelToggle: CompressedJsonParam,
  markerNormalizationValues: CompressedJsonParam,
  [markerChannelHistogramsQueryParam]: CompressedJsonParam,
  expandedSlideResults: CompressedJsonParam,
  [resultReviewIntentParam]: CompressedJsonParam,
  ...annotationAssignmentIdViewerQuerySchema,
  viewersStainPreferences: DelimitedArrayParam,
  ...fromPairs(times(MAX_VIEWERS, (viewerIndex) => [`slideInfobarTab-${viewerIndex}`, StringParam])),
};
